"use client";

import LegalNav from "../LegalNav";

export default function LegalContent({ html }) {
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: html }} />
      <LegalNav />
    </>
  );
}
